import { render, staticRenderFns } from "./serverAdd.vue?vue&type=template&id=5f6a4ac7&scoped=true"
import script from "./serverAdd.vue?vue&type=script&lang=js"
export * from "./serverAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6a4ac7",
  null
  
)

export default component.exports